import { render, staticRenderFns } from "./AddProductModal.vue?vue&type=template&id=30665199&scoped=true"
import script from "./AddProductModal.vue?vue&type=script&lang=js"
export * from "./AddProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30665199",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30665199')) {
      api.createRecord('30665199', component.options)
    } else {
      api.reload('30665199', component.options)
    }
    module.hot.accept("./AddProductModal.vue?vue&type=template&id=30665199&scoped=true", function () {
      api.rerender('30665199', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/AddProductModal.vue"
export default component.exports